import { React } from "react";

import "./404.css";

const NotFound = () => {
  return (
    <div className="jumbotron fnf add_zindex">
      <div className="broimg fnf">
        <img
          src="assets/broken_robot.webp"
          alt="Broken Robot"
          draggable="false"
          className="fnf"
        />
      </div>
      <div className="d-md-flex align-items-md-center errorcontent fnf">
        <h1 className="error fnf">404</h1>
        <h4 className="text-center fnf">
          Sorry, the page you requested was not found
        </h4>
        <a href="/" className="button fnf">
          <span className="fnf"></span>
          <div className="fnf">Back To Home</div>
        </a>
      </div>
    </div>
  );
};

export default NotFound;
